export const PLAYBACK_RATES = [2.5, 2, 1.75, 1.5, 1.25, 1, 0.75, 0.5];
